export const firebaseConfig = {
    apiKey: "AIzaSyA5Nqo8A9RukdMXWxSQSg-Qn3nzPf-qvNg",
    authDomain: "tienen-fietst.firebaseapp.com",
    databaseURL: "https://tienen-fietst.firebaseio.com",
    projectId: "tienen-fietst",
    storageBucket: "tienen-fietst.appspot.com",
    messagingSenderId: "296837258688"
    };
